module.exports = __webpack_public_path__ + "img/file-certificate.315a9086.svg";